var map = {
	"./bi.js": "Cf39",
	"./dataManage.js": "ePCC"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "q6aq";


//////////////////
// WEBPACK FOOTER
// ./src/router/dataManage nonrecursive ^(?!\.\/index|\.\/cockpit).*\.js$
// module id = q6aq
// module chunks = 225